




























import Vue from 'vue';
import Component from 'vue-class-component';
import {Getter} from "vuex-class";
import {MngCompanyMessageSection} from "@/models/LobbyDataResponse.model";
import {StoreNamespace} from "@/globals/StoreNamespaceGlobal";

@Component({})
export default class MngCompanyMessageSectionComponent extends Vue {

    @Getter("mngCompanyMessageSection", StoreNamespace.LOBBY) mngCompanyMessageSection!: MngCompanyMessageSection;

}
